export default __webpack_public_path__ + "static/properties/20260316-200400.316/audit_de.properties";